import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/auth-context';

import { ConfigProvider } from 'antd';
import esES from 'antd/es/locale/es_ES';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';

const themeConfig = {
    token: {
        colorPrimary: '#64c0ff',
    },
    components: {
        // Table: { headerBg: '#98d0eb', headerColor: '#ffffff' },
        Modal: { titleColor: '#1944a3' },
    },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <ConfigProvider locale={esES} theme={themeConfig}>
                    <App />
                </ConfigProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
